// extracted by mini-css-extract-plugin
export default {"dot1":"dot1--HOK2V","dot2":"dot2--_gxkh","dot3":"dot3--PhcEH","jump":"jump--OJSIl"};